<template>
    <div id="login-page" class="size-full flex items-center justify-center">
        <div class="w-[450px] border rounded-lg p-6 shadow-lg bg-white">
            <h2 class="text-[20px] text-center font-semibold mb-2">登录</h2>
            <a-input v-model="username" size="large" placeholder="用户名">
                <template #prefix>
                    <a-icon type="user" />
                </template>
            </a-input>
            <a-input v-model="password" type="password" size="large" class="!mt-6" @keydown.enter="onLogin"
                placeholder="密码">
                <template #prefix>
                    <a-icon type="lock" />
                </template>
            </a-input>
            <div class="mt-6 flex justify-center">
                <a-button type="primary" class="w-full" @click="onLogin" size="large">登录</a-button>
            </div>
        </div>
    </div>
</template>

<style></style>

<script>
import { login } from "@/api/user";
import promiseFlat from "@/utils/promiseFlat";
import local from "@/utils/storage";
export default {
    name: "login-page",
    data() {
        return {
            username: "",
            password: "",
        };
    },
    methods: {
        async onLogin() {
            const { username, password } = this;
            const [err, result] = await promiseFlat(
                login({
                    username,
                    password,
                    signFlag: 0,
                })
            );
            if (err) {
                this.$message.error(err);
                return;
            }
            console.log("result", result);
            local.set("token", result.token);
            this.$router.replace({
                path: "/home/",
            });
        },
    },
};
</script>

<style>
#login-page {
    background: #f0f2f5 url(../../assets/background.svg) no-repeat 50%
}
</style>